import axios from "axios";
import { DEVREV_TOKEN_URL } from 'src/globals';

export async function getSessionTokenForDevRevUser(organisationId, userId, accessToken) {
  try {
    const config = {
      method: 'get',
      url: DEVREV_TOKEN_URL,
      headers: {
        'organisation-id': organisationId,
        'user-id': userId,
        'access-token': accessToken
      }
    };

    const response = await axios.request(config);
    return response.data.data;
  } catch (error) {
    return null;
  }
}


